"use strict";

var _interopRequireDefault = require("E:/dianlala_project/\u7535\u5566\u5566/cd-vue-admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es7.object.values");
var _echarts = _interopRequireDefault(require("echarts"));
var _filter = _interopRequireDefault(require("@/components/filterDrawer/filter"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

require('echarts/theme/macarons'); // echarts theme
var _default = exports.default = {
  name: 'dayMoney',
  components: {
    drawer: _filter.default
  },
  data: function data() {
    var _this = this;
    return {
      form: {},
      list: [],
      tableList: [],
      listQuery: {},
      beginOptions: {
        disabledDate: function disabledDate(time) {
          if (_this.form.end) {
            return time.getTime() > _this.form.end || time.getTime() > new Date(new Date().toLocaleDateString()).getTime();
          } else {
            return time.getTime() > new Date(new Date().toLocaleDateString()).getTime();
          }
        }
      },
      endOptions: {
        disabledDate: function disabledDate(time) {
          if (_this.form.begin) {
            return time.getTime() < _this.form.begin || time.getTime() > new Date(new Date().toLocaleDateString()).getTime();
          } else {
            return time.getTime() > new Date(new Date().toLocaleDateString()).getTime() + 86400;
          }
        }
      }
    };
  },
  mounted: function mounted() {
    this.getList();
  },
  methods: {
    /**
     * 搜索查询
     */
    toQuery: function toQuery() {
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      if (type == 1) this.form = {};
      this.listQuery.start = 1;
      this.getList();
    },
    getList: function getList() {
      var _this2 = this;
      var url = 'agentapi/statistics/stat_user_scan_data';
      var listQuery = Object.assign(this.form, this.listQuery, {});
      if (listQuery.begin) listQuery.begin = this.parseTime(listQuery.begin, '{y}-{m}-{d}');
      if (listQuery.end) listQuery.end = this.parseTime(listQuery.end, '{y}-{m}-{d}');
      this.day = [];
      this.day_scan_num = [];
      this.day_scan_user_num = [];
      this.day_used_num = [];
      this.day_using_user_num = [];
      this.$get(url, listQuery).then(function (res) {
        _this2.list = Object.values(JSON.parse(JSON.stringify(res))).reverse();
        _this2.tableList = Object.values(res);
        for (var i in res) {
          _this2.day.push(res[i].date);
          _this2.day_scan_num.push(res[i].day_scan_num);
          _this2.day_scan_user_num.push(res[i].day_scan_user_num);
          _this2.day_used_num.push(res[i].day_used_num);
          _this2.day_using_user_num.push(res[i].day_using_user_num);
        }
        _this2.initChart();
      }).catch(function () {});
    },
    /**
     * 设置图表
     */
    initChart: function initChart() {
      var that = this;
      this.chart = _echarts.default.init(document.getElementById('moneyChart'), 'macarons');
      this.chart.setOption({
        xAxis: {
          type: 'category',
          data: that.day,
          boundaryGap: false,
          axisTick: {
            show: false
          }
        },
        yAxis: {
          axisTick: {
            show: false
          },
          type: 'value'
        },
        grid: {
          left: 20,
          right: 20,
          bottom: 20,
          top: 40,
          containLabel: true
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross'
          },
          padding: [5, 10]
        },
        dataZoom: [{
          show: true,
          realtime: true,
          start: 0,
          end: 100
        }],
        legend: {
          data: ['扫码次数', '扫码人数', '使用次数', '使用人数']
        },
        series: [{
          name: '扫码次数',
          itemStyle: {
            normal: {
              color: '#3888fa',
              lineStyle: {
                color: '#3888fa',
                width: 2
              },
              areaStyle: {
                color: '#f3f8ff'
              }
            }
          },
          smooth: true,
          type: 'line',
          data: this.day_scan_num,
          animationDuration: 2800,
          animationEasing: 'quadraticOut'
        }, {
          name: '扫码人数',
          smooth: true,
          type: 'line',
          data: this.day_scan_user_num,
          animationDuration: 2800,
          animationEasing: 'quadraticOut'
        }, {
          name: '使用次数',
          smooth: true,
          type: 'line',
          data: this.day_used_num,
          animationDuration: 2800,
          animationEasing: 'quadraticOut'
        }, {
          name: '使用人数',
          smooth: true,
          type: 'line',
          data: this.day_using_user_num,
          animationDuration: 2800,
          animationEasing: 'quadraticOut'
        }]
      });
    }
  }
};